<section #rootElement class="billboard" tabindex="-1">
	<div class="billboard-header">
		<h2 class="billboard-title">General Info</h2>
		<div class="billboard-actions d-flex">
			<div class="text-center flex-grow-0 mx-2 align-self-center">
				@if (requests?.length > 0) {
					<ae-icon-tooltip
						message="A request to change this info is pending"
						type="pending"
					/>
				}
			</div>
			@if (canEditProfile) {
				<button
					aria-label="Edit General Info"
					class="btn btn-default"
					id="profile.contact.edit.enable"
					type="button"
					[disabled]="loading"
					(click)="enableEdit()"
				>
					Edit
				</button>
			}
		</div>
	</div>
	<div class="billboard-body">
		<div *aeSpinWhile="loading">
			<!-- Name -->
			<h3 class="fs-5 fw-bold">Demographics</h3>
			<div class="row mb-1">
				<div class="col-xl-12 col-lg-12 mb-3">
					<div class="fw-bold" id="profile.info.view.legal_name.title">
						Legal Name
					</div>
					<div id="profile.info.view.legal_name.value">
						<ng-container *ngTemplateOutlet="hasUpdateNameValue" />
					</div>
				</div>
			</div>
			<div class="row mb-1">
				<div class="col-xl-3 col-lg-4 mb-3">
					<div class="fw-bold" id="profile.info.view.birthdate.title">
						Birthdate
					</div>
					<ng-container
						*ngTemplateOutlet="
							hasUpdatedValue;
							context: {
								$implicit: updatedStudentInfoMap?.get('dob'),
								id: 'profile.info.view.birthdate.value',
								type: 'date',
							}
						"
					/>
				</div>
				@if (!isStudentApp) {
					<div class="row">
						<div class="col-xl-3 col-lg-4 mb-3">
							<div class="fw-bold" id="profile.info.view.gender.title">
								Gender
							</div>
							<ng-container
								*ngTemplateOutlet="
									hasUpdatedValue;
									context: {
										$implicit: updatedStudentInfoMap?.get(
											'profile_student_gender'
										),
										id: 'profile.info.view.gender.value',
									}
								"
							/>
						</div>
						<div class="col-xl-3 col-lg-4 mb-3">
							<div class="fw-bold" id="profile.info.view.race.title">Race</div>
							<ng-container
								*ngTemplateOutlet="
									hasUpdatedValue;
									context: {
										$implicit: updatedStudentInfoMap?.get('profile_field_race'),
										id: 'profile.info.view.race.value',
									}
								"
							/>
						</div>
						<div class="col-xl-3 col-lg-4 mb-3">
							<div class="fw-bold" id="profile.info.view.ethnicity.title">
								Ethnicity
							</div>
							<ng-container
								*ngTemplateOutlet="
									hasUpdatedValue;
									context: {
										$implicit: updatedStudentInfoMap?.get(
											'profile_field_ethnicity'
										),
										id: 'profile.info.view.ethnicity.value',
									}
								"
							/>
						</div>
					</div>
				}
			</div>
			<div class="row mb-1">
				<div class="col-xl-3 col-lg-4">
					<div class="fw-bold" id="profile.info.view.preferred_name.title">
						Preferred First Name
					</div>
					<div id="profile.info.view.preferred_name.value">
						<ng-container
							*ngTemplateOutlet="
								hasUpdatedValue;
								context: {
									$implicit: updatedStudentInfoMap?.get(
										'profile_preferred_name'
									),
								}
							"
						/>
					</div>
				</div>
				@if (!isStudentApp) {
					<div class="col-xl-3 col-lg-4">
						<div class="fw-bold" id="profile.info.view.pronunciation.title">
							Pronunciation
						</div>
						<div id="profile.info.view.pronunciation.value">
							<ng-container
								*ngTemplateOutlet="
									hasUpdatedValue;
									context: {
										$implicit: updatedStudentInfoMap?.get(
											'profile_pronunciation'
										),
									}
								"
							/>
						</div>
					</div>
				}
			</div>

			<!-- Social -->
			@if (
				hasSomeKey(profileData, [
					'profile_about',
					'profile_city',
					'profile_state',
					'profile_intro_video',
				])
			) {
				<h3 class="fs-5 fw-bold">Social</h3>
				@if (hasKey(profileData, 'profile_about')) {
					<div class="mb-3">
						<div class="fw-bold" id="profile.info.view.about_me.title">
							About Me
						</div>
						<div id="profile.info.view.about_me.value">
							{{
								profileData?.profile_about ? profileData?.profile_about : '-'
							}}
						</div>
					</div>
				}
				<div class="row">
					<div class="col-xl-3 col-lg-6 mb-3">
						<div class="fw-bold" id="profile.info.view.city.title">City</div>
						<div id="profile.info.view.city.value">
							{{ profileData?.profile_city ? profileData?.profile_city : '-' }}
						</div>
					</div>
					@if (hasKey(profileData, 'profile_state')) {
						<div class="col-xl-3 col-lg-3 mb-3">
							<div class="fw-bold" id="profile.info.view.state.title">
								State
							</div>
							<div id="profile.info.view.state.value">
								{{
									profileData?.profile_state ? profileData?.profile_state : '-'
								}}
							</div>
						</div>
					}
				</div>
				@if (hasKey(profileData, 'profile_intro_video')) {
					<div class="row">
						<div class="col-lg-12">
							<div class="fw-bold" id="profile.info.view.intro_video.title">
								Welcome Video
							</div>
							<div id="profile.info.view.intro_video.value">
								@if (profileData.profile_intro_video) {
									<div>
										<a
											target="_blank"
											[href]="
												welcomeVideo(profileData.profile_intro_video)
													| dompurify: 5
											"
											>{{ welcomeVideo(profileData.profile_intro_video) }}</a
										>
									</div>
								}
								@if (!profileData.profile_intro_video) {
									<div>-</div>
								}
							</div>
						</div>
					</div>
				}
			}
		</div>
	</div>
</section>

<ng-template #hasUpdateNameValue>
	<!--build new name-->

	<span
		[class.fst-italic]="updatedStudentInfoMap?.get('profile_first_name')?.new"
		>{{
			updatedStudentInfoMap?.get('profile_first_name')?.new ??
				profileData?.profile_first_name
		}}</span
	>
	<span
		[class.fst-italic]="
			updatedStudentInfoMap?.get('profile_preferred_name')?.new
		"
	>
		{{
			updatedStudentInfoMap?.get('profile_preferred_name')?.new ??
				profileData?.profile_preferred_name | ifEmpty: ''
		}}
	</span>
	<span
		[class.fst-italic]="updatedStudentInfoMap?.get('profile_middle_name')?.new"
	>
		{{
			updatedStudentInfoMap?.get('profile_middle_name')?.new ??
				profileData?.profile_middle_name | ifEmpty: ''
		}}
	</span>
	<span
		[class.fst-italic]="updatedStudentInfoMap?.get('profile_last_name')?.new"
	>
		{{
			updatedStudentInfoMap?.get('profile_last_name')?.new ??
				profileData?.profile_last_name | ifEmpty: ''
		}}
	</span>
	<span
		[class.fst-italic]="updatedStudentInfoMap?.get('profile_maiden_name')?.new"
	>
		{{ getMaidenName() }}
	</span>
	<span [class.fst-italic]="updatedStudentInfoMap?.get('profile_suffix')?.new">
		{{
			updatedStudentInfoMap?.get('profile_suffix')?.new ??
				profileData?.profile_suffix | ifEmpty: ''
		}}
	</span>

	@if (getNameUpdate()) {
		<ng-container
			*ngTemplateOutlet="
				pendingApprovalTemplate;
				context: {
					$implicit: 'legal_name',
				}
			"
		/>
	}
</ng-template>

<ng-template #hasUpdatedValue let-id="id" let-item let-type="type">
	@if (item) {
		<div class="d-flex" [id]="id">
			<span [class.fst-italic]="item.new">
				@if (type === 'date') {
					{{
						item.new ? (item.new | date | ifEmpty) : (item.old | date | ifEmpty)
					}}
				} @else {
					{{ item.new ? item.new : (item.old | ifEmpty) }}
				}
			</span>
			@if (item.new) {
				<ng-container
					*ngTemplateOutlet="
						pendingApprovalTemplate;
						context: {
							$implicit: item.name,
						}
					"
				/>
			}
		</div>
	}
</ng-template>

<ng-template #pendingApprovalTemplate let-name>
	<button
		class="btn btn-icon text-info ms-1"
		id="lunchbox.pages.studentinfo.{{ name }}"
		ngbTooltip="This change is pending approval."
		type="button"
	>
		<i aria-hidden="true" class="fal fa-mailbox-open-letter"></i>
	</button>
</ng-template>
